<script>
export default {
  name: 'ReactiveStyle',
  render (createElement) {
    return createElement('style', this.$slots.default)
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/reactive-style/reactive-style.vue